import React from 'react';
import '../assets/styles/DashBoard.css';

const BranchDashboard = () => {
    return (
        <div className=" container-fluid dashboard">
        
            <div className="menu">
              <h1>Main branch dashboard</h1>
              
              <h1>Main branch dashboard</h1>
              <h1>Main branch dashboard</h1>
              <h1>Main branch dashboard</h1>
              <h1>Main branch dashboard</h1>
              <h1>Main branch dashboard</h1>
              <h1>Main branch dashboard</h1>
              <h1>Main branch dashboard</h1>
              <h1>Main branch dashboard</h1>
              <h1>Main branch dashboard</h1>
              <h1>Main branch dashboard</h1>
              <h1>Main branch dashboard</h1>
              <h1>Main branch dashboard</h1>
              <h1>Main branch dashboard</h1>
              <h1>Main branch dashboard</h1>
              <h1>Main branch dashboard</h1>
              <h1>Main branch dashboard</h1>
            </div>
        </div>
    );
};

export default BranchDashboard;
